import React from 'react'
import { useTranslation } from 'i18n'

import ClipboardCheckIcon from 'images/inline/clipboard-check.svg'
import ClipboardIcon from 'images/inline/clipboard.svg'
import CopyLinkIcon from 'images/inline/copy-link-icon.svg'

import './CopyToClipboardButton.scss'

export const CopyToClipboardButton = ({
  label,
  onClick = function () {},
  variant = 'default',
}) => {
  const { t } = useTranslation('tipsAndTricks')
  const [isCopied, setIsCopied] = React.useState(false)
  const buttonClassVariants = {
    outlined: 'copy-button-outlined',
    default: 'btn themed-button',
  }

  const buttonIconVariants = {
    default: isCopied ? <ClipboardCheckIcon /> : <ClipboardIcon />,
    outlined: isCopied ? <ClipboardCheckIcon /> : <CopyLinkIcon />,
  }

  return (
    <button
      className={`copy-button-style`}
      onClick={() => {
        setIsCopied(true)
        onClick()
        setTimeout(() => {
          setIsCopied(false)
        }, 5000)
      }}
    >
      {variant === 'outlined' && buttonIconVariants[variant]}
      <span>{label || t('copyToClipboard')}</span>
      {variant === 'default' && buttonIconVariants[variant]}
    </button>
  )
}
export default CopyToClipboardButton
